/**
 * Sidebar mic presentation — single unified mic control for all products.
 * Button reflects any active session; sidebar popover/streaming follow sidebar recording only.
 */
export function getSidebarMicUiState({
  isRecording,
  isAnyMicActive = false,
}) {
  return {
    buttonActive: isAnyMicActive,
    dictationActive: isRecording,
  };
}
